import { Component, OnDestroy, OnInit } from "@angular/core"
import { Title } from "@angular/platform-browser"
import { ActivatedRoute, Params } from "@angular/router"
import { Subscription } from "rxjs"
import { FacetingService } from "../../services/faceting.service"
import { SearchingService } from "../../services/searching.service"
import { SearchInfoModel } from "../../models/searchInfo.model"
import { UserService } from "../../services/user.service"
import { routeAnimations, routeTransition } from "../../utils/animations"

@Component({
    templateUrl: "./search-collection-page.component.html",
    styleUrls: ["./search-collection-page.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class SearchCollectionPageComponent implements OnInit, OnDestroy {
    public subscriptions: Subscription[] = []
    public searchInfo: SearchInfoModel = new SearchInfoModel({})
    public collectionSlug: string = ""

    constructor(
        private facetingService: FacetingService,
        private searchingService: SearchingService,
        private route: ActivatedRoute,
        private titleService: Title,
        public userService: UserService
    ) {
        this.titleService.setTitle("Search Classroom Resources | PBS LearningMedia")
    }

    public ngOnInit() {
        this.subscriptions.push(
            this.route.queryParams.subscribe((queryParams: Params) => {
                this.facetingService.updateFacetsFromQueryParams(queryParams)
            }),
            this.route.params.subscribe((params: Params) => {
                if (params && params.slug) {
                    this.searchingService.getPremiumCollectionSearchInfo(params.slug)
                    this.collectionSlug = params.slug
                }
            }),
            this.searchingService.searchInfo.subscribe((data: SearchInfoModel) => {
                if (data) {
                    this.searchInfo = data
                }
            })
        )
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
